export const AUTH_TOKEN = "AUTH_TOKEN";
export const SET_TOKEN = "SET_TOKEN";
export const SET_USER = "SET_USER";
export const GET_USER = "GET_USER";
export const GET_TOKEN = "GET_TOKEN";
export const LOG_OUT = "LOG_OUT";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const USER_REQUEST = "USER_REQUEST";
export const SET_CURRENT_SITE = "SET_CURRENT_SITE";
